// extracted by mini-css-extract-plugin
export default {"blueButton":"BlueButton_blueButton__xEHjS","lightBlueButton":"BlueButton_lightBlueButton__LIJGP"};